import { useContext, useEffect, useState } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { useRecoilState, useRecoilValue } from 'recoil';
import { resetRecoil, setRecoil } from 'recoil-nexus';
import styled from 'styled-components';
import { SelectType } from '../components/DropdownSelect';
import AddMultiStoreModal from '../components/modal/AddMultiStoreModal';
import InterphoneModal from '../components/modal/InterphoneModal';
import InterphoneController, {
  CALL_TYPE_RECEIVER,
  CALL_TYPE_SENDER,
  InterphoneAreaType,
} from '../controller/InterphoneController';
import NoticeController from '../controller/NoticeController';
import StoreController from '../controller/StoreController';
import { requestNotificationPermission } from '../firebase';
import { AuthContext } from '../navigation/AuthProvider';
import { areaState } from '../recoil/area';
import { useConciergeState } from '../recoil/concierge';
import {
  fcmConciergeCountState,
  fcmInterphoneState,
  fcmSalesCountState,
  InterphoneType,
} from '../recoil/fcmMessage';
import { hotelAreaIdState, useInterphoneState } from '../recoil/interphone';
import { introPreviewState } from '../recoil/introPreview';
import AsyncLocalStorage from '../utils/AsyncLocalStorage';
import { getDecryptObject } from '../utils/crypto';
import { handleFirebaseMsg } from '../utils/handleFirebaseMsg';
import MobileSidebar from './sidebar/MobileSidebar';
import Sidebar from './sidebar/Sidebar';
import { pushButtonClickState } from '../recoil/pushButtonClick';
import MobileFooter from './hotel/mobileFooter';

type titleType = {
  title: string;
  content: string;
};
interface AccordionItem {
  title: string;
  link?: string;
  content?: { link: string; title: string }[];
}

let countTemp = 0;
let oWindow: Window | null = null;

export const ProtectedLayout = (oProps: any) => {
  const navigate = useNavigate();

  const userAgent = navigator.userAgent.toLowerCase();

  const { userInfo, currentStore, handleLogout } = useContext(AuthContext);
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [visibleMultiStoreModal, setVisibleMultiStoreModal] = useState<boolean>(false);
  const [visibleInterphoneModal, setVisibleInterphoneModal] = useState<boolean>(false);

  const [currentTitle, setCurrentTitle] = useState<titleType>({ title: '', content: '' });
  const [defaultStoreInfo, setDefaultStoreInfo] = useState<SelectType>(currentStore);

  const [isUnReadNotice, setIsUnreadNotice] = useState<boolean>(false);

  const fcmInterphoneFlag = useRecoilValue<InterphoneType>(fcmInterphoneState);
  const [interphoneArea, setInterphoneArea] = useRecoilState<string | null>(areaState);

  const location = useLocation();

  const accordionData: AccordionItem[] = [
    {
      title: '판매/정산 관리',
      content: [
        { link: '/manage/salemanager', title: 'POS(판매시점) 관리' },
        { link: '/manage/delivery', title: '객실관리팁 현황' },
        { link: '/manage/sales', title: '매출/정산 조회' },
      ],
    },
    {
      title: '고객/객실 관리',
      content: [
        { link: '/room/checkout', title: '퇴실 알림' },
        { link: '/room/checkList', title: '퇴실 알림 결과보기' },
        { link: '/room/roomSale', title: '퇴실•연장 상품관리' },
        { link: '/room/request', title: '고객 요청•메시지' },
        { link: '/room/device', title: '노크노크 기기관리' },
        { link: '/room/interphone', title: '인터콤 발신' },
      ],
    },
    {
      title: '호텔 관리',
      content: [
        { link: '/info/guide', title: '호텔 컨텐츠 관리' },
        { link: '/info/StaffSetting', title: '근무자 등록/관리' },
      ],
    },
    {
      title: '설정',
      content: [
        { link: '/setting/hotelInfo', title: '호텔 정보 설정' },
        { link: '/setting/pickup', title: '배달 픽업존 설정' },
        { link: '/setting/tip', title: '배달 객실관리 팁' },
        { link: '/setting/roomType', title: '객실 그레이드 설정' },
        { link: '/setting/concierge', title: '컨시어지 관리' },
        { link: '/setting/area', title: '인터콤 설정' },
      ],
    },
  ];

  if (process.env.REACT_APP_ENV === 'DEV') {
    accordionData.push({
      title: '연구실',
      link: '/hotel/event',
    });
  }

  const getAccordionTitle = () => {
    for (let i = 0; i < accordionData.length; i++) {
      if (accordionData[i].content) {
        for (let j = 0; j < accordionData[i].content!.length; j++) {
          if (location.pathname.indexOf(accordionData[i].content![j].link) !== -1) {
            return { title: accordionData[i].title, content: accordionData[i].content![j].title };
          }
        }
      } else {
        if (location.pathname.indexOf(accordionData[i].link!) !== -1) {
          return { title: '', content: accordionData[i].title };
        }
      }
    }
    return { title: '', content: '' };
  };

  // API
  // 미열람 공지사항 수
  const getUnreadCount = async () => {
    try {
      const oParams = {
        store_id: currentStore.value,
      };
      const oRes = await NoticeController.getUnreadCount(oParams);

      if (oRes && oRes.data) {
        const oResponse = oRes.data;
        console.log('getlist', oResponse);
        if (oResponse.data) {
          setIsUnreadNotice(oResponse.data.unreadCount > 0);
        }
      }
    } catch (err) {
      console.log('err---->', err);
    }
  };

  // 인터폰 수신받을 때, 발신자 정보
  const getCallers = async () => {
    try {
      const oParams = {
        manage_id: fcmInterphoneFlag.interphone_call_manage_id,
      };
      const oRes = await InterphoneController.getCallers(oParams);

      if (oRes && oRes.data) {
        const oResponse = oRes.data;
        console.log('getCallers', oResponse);
        if (oResponse.data) {
          if (fcmInterphoneFlag.type === CALL_TYPE_RECEIVER) {
            setInterphoneArea(oResponse.data.sender_name);
          } else if (fcmInterphoneFlag.type === CALL_TYPE_SENDER) {
            setInterphoneArea(oResponse.data.receiver_name);
          }
        }
      }
    } catch (err) {
      console.log('getCallers err---->', err);
    }
  };

  // 컨시어지 사용 여부 불러오기
  const getConciergeList = async () => {
    try {
      const oParams = {
        store_id: currentStore.value,
      };
      const oResponse = await StoreController.getConciergeList(oParams);
      if (oResponse && oResponse.data) {
        const oRes = oResponse.data;
        if (oRes && oRes.data) {
          setRecoil(useConciergeState, oRes.data.concierge_manage.status);
        }
      }
    } catch (e) {
      console.error('err => ', e);
    }
  };

  // 인터폰 사용 여부 불러오기
  const getInterphoneUseStatus = async () => {
    try {
      const oParams = {
        hotel_id: currentStore.value,
      };
      const oRes = await InterphoneController.getInterphoneUseStatus(oParams);

      if (oRes && oRes.data) {
        const oResponse = oRes.data;
        console.log('getInterphoneUseStatus', oResponse);
        if (oResponse.data) {
          setRecoil(useInterphoneState, oResponse.data.isInterphoneUse);
        }
      }
    } catch (err) {
      console.log('getInterphoneUseStatus err---->', err);
    }
  };

  // 호텔 구역 리스트에서 지정된 areaId 찾기
  const hotelAreaList = async () => {
    try {
      const oParams = {
        hotel_id: currentStore.value,
      };
      const oRes = await InterphoneController.hotelAreaList(oParams);

      if (oRes && oRes.data) {
        const oResponse = oRes.data;
        console.log('hotelAreaList', oResponse);
        if (oResponse.data && oResponse.data.hotelAreaData) {
          const selectedArea: InterphoneAreaType | undefined = oResponse.data.hotelAreaData.find(
            (item: InterphoneAreaType) => item.registerByThisDevice === true,
          );
          console.log('selectedArea', selectedArea);
          if (selectedArea) {
            setRecoil(hotelAreaIdState, selectedArea.hotel_area_id);
            AsyncLocalStorage.setItem('hotelAreaId', JSON.stringify(selectedArea.hotel_area_id));
          } else {
            resetRecoil(hotelAreaIdState);
            AsyncLocalStorage.removeItem('hotelAreaId');
          }
        }
      }
    } catch (err) {
      console.log('hotelAreaList err---->', err);
    }
  };

  const toggle = () => {
    setIsOpen(!isOpen);
  };

  const checkCurrentStore = async () => {
    const currentStore = await AsyncLocalStorage.getItem('hotel-currentStore');
    if (!currentStore) {
      handleLogout();
    }
  };

  useEffect(() => {
    if (location.pathname.indexOf('/manage/salemanager') !== -1 && 'salemanager') {
      countTemp = 0;
      setRecoil(fcmSalesCountState, 0);
    } else if (location.pathname.indexOf('/room/request') !== -1) {
      countTemp = 0;
      setRecoil(fcmConciergeCountState, 0);
    } else if (location.pathname.indexOf('/notification/list') !== -1) {
      setIsUnreadNotice(false);
    }
    setCurrentTitle(getAccordionTitle());

    if (!/kakaotalk/i.test(userAgent)) {
      checkCurrentStore();
    }
  }, [location]);

  // webView firebase msg
  useEffect(() => {
    const handleMessage = async (event: any) => {
      let message = getDecryptObject(event.data);
      console.log('webview message', message, message.type);

      if (message.type === 'set_fb_token') {
        AsyncLocalStorage.setItem('hotel-firebaseToken', message.data.firebase_token);
      } else if (message.type === 'firebase_msg') {
        handleFirebaseMsg(message, countTemp);
      } else if (message.type === 'firebase_navigate') {
        navigate(message.data);
      } else if (message.type === 'push_button_click') {
        setRecoil(pushButtonClickState, message.data);
      }
    };

    document.addEventListener('message', handleMessage);
  }, []);

  // FCM Token msg
  useEffect(() => {
    const receiveData = async (event: any) => {
      const receivedData = event.data;
      console.log('FCM message', event.data);

      handleFirebaseMsg(receivedData, countTemp);
    };

    hotelAreaList();

    getUnreadCount();
    requestNotificationPermission();
    getInterphoneUseStatus();
    getConciergeList();
    if ('serviceWorker' in navigator) {
      console.log('serviceWorker');
      navigator.serviceWorker.addEventListener('message', receiveData);

      return () => {
        navigator.serviceWorker.removeEventListener('message', receiveData);
      };
    }
  }, []);

  useEffect(() => {
    if (!userInfo && !/kakaotalk/i.test(userAgent)) {
      setTimeout(() => {
        navigate('/', { replace: true });
      }, 50);
    }
  }, [userInfo]);

  // FCM 인터폰 수신 후 송신자 정보 호출
  useEffect(() => {
    if (fcmInterphoneFlag.interphone_call_manage_id) {
      getCallers();
    }
  }, [fcmInterphoneFlag.interphone_call_manage_id]);

  // getCaller 호출 후 인터폰 모달 활성화
  useEffect(() => {
    if (interphoneArea) {
      setVisibleInterphoneModal(true);
    }
  }, [interphoneArea]);

  // New page
  const loadNewWindow = () => {
    oWindow = window.open(`${process.env.REACT_APP_API_CEO_URL}`, '_blank');
  };

  return (
    <MainStyle>
      <div className="layoutWrap">
        <div className="mobileHeader">
          <MobileSidebar
            toggle={toggle}
            isOpen={isOpen}
            setIsOpen={setIsOpen}
            {...oProps}
            accordionData={accordionData}
            currentStore={defaultStoreInfo}
            currentTitle={currentTitle}
            loadNewWindow={loadNewWindow}
            isUnReadNotice={isUnReadNotice}
          />
        </div>
        <div className="screen">
          <div className="leftWrap">
            <Sidebar
              accordionData={accordionData}
              currentStore={defaultStoreInfo}
              currentTitle={currentTitle}
              loadNewWindow={loadNewWindow}
              isUnReadNotice={isUnReadNotice}
              {...oProps}
            />
          </div>
          <div className="rightWrap" onClick={() => setIsOpen(false)}>
            {location.pathname.indexOf('/sales/monthly') !== -1 ? (
              <></>
            ) : (
              <div
                className={`headerWrap ${
                  (location.pathname.indexOf('/sales/calendar') !== -1 && 'wide',
                  location.pathname.indexOf('/room/checkout') !== -1 && 'widewidth')
                }`}>
                <div className="categoryTitle">
                  <h3>{currentTitle.title}</h3>
                  {currentTitle.title !== '' && <span>&gt;</span>}
                  <h2>{currentTitle.content}</h2>
                  {location.pathname.indexOf('/hotel/sales') !== -1 && (
                    <div className="warningSign" style={{ marginLeft: '20px' }}>
                      <img src={`${process.env.PUBLIC_URL}/svg/ic_warning.svg`} alt="ic" />
                      <p>
                        이 페이지에서는 간단한 주문 접수만 가능합니다. 자세한 내용은 포스에서 확인해
                        주세요.
                      </p>
                    </div>
                  )}
                </div>
                <div className="headerButtonWrap">
                  {location.pathname.indexOf('/guide/edit') !== -1 && (
                    <button className="menuView" onClick={() => setRecoil(introPreviewState, true)}>
                      미리보기
                    </button>
                  )}
                </div>
              </div>
            )}
            <Outlet
              context={{
                currentStore: defaultStoreInfo!,
              }}
            />
          </div>
        </div>
        <MobileFooter />
      </div>
      <AddMultiStoreModal
        isVisible={visibleMultiStoreModal}
        setVisible={setVisibleMultiStoreModal}
      />
      {visibleInterphoneModal && fcmInterphoneFlag.interphone_call_manage_id && (
        <InterphoneModal
          isVisible={visibleInterphoneModal}
          setVisible={setVisibleInterphoneModal}
        />
      )}
    </MainStyle>
  );
};

export const MainStyle = styled.div`
  /* 모바일 */
  .mobileHeader {
    display: none;
  }

  /* screen */
  .screen {
    flex: 1;
    width: 100vw;
    max-width: 100%;
    overflow-y: hidden;
    display: flex;
    justify-content: flex-start;
  }

  .layoutWrap {
    display: flex;
    flex-direction: column;
    width: 100%;
    position: relative;
    min-height: 100vh;
    min-height: 100dvh;
    max-height: 100vh;
    max-height: 100dvh;
    -webkit-user-select: none; /* Chrome, Safari, Edge */
    -moz-user-select: none; /* Firefox */
    -ms-user-select: none; /* Internet Explorer/Edge */
    user-select: none; /* 일반적인 방법 */
  }
  /* 고정 사이드바 */
  .leftWrap {
    min-width: 250px;
    max-width: 250px;
    background: #2b2b2b;
    min-height: 100vh;
    height: auto;
    z-index: 99;
    overflow-y: auto;
  }

  /* 오른쪽 화면 공통사항 */
  .rightWrap {
    display: flex;
    flex-direction: column;
    overflow-y: auto;
    flex: 1;
    padding: 27px 46px;
    background: #f7f7f7;
  }

  /* headerWrap */
  .headerWrap {
    width: 800px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .widewidth {
    width: 90%;
  }
  .categoryTitle {
    display: flex;
    align-items: center;
    h2 {
      font-size: 20px;
      font-weight: 700;
      color: #555;
    }
    h3 {
      font-size: 20px;
      font-weight: 500;
      color: #979797;
    }
    span {
      margin: 0 10px;
      color: #979797;
      font-weight: 500;
    }
  }
  .headerWrap.wide {
    width: 1000px;
  }
  .headerButtonWrap {
    position: absolute;
    display: flex;
    gap: 17px;
    right: 0;
    top: 0;
    padding: 23px 46px;

    h2 {
      font-size: 16px;
      font-weight: 600;
      color: #40977f;
    }
    button {
      padding: 8px 19px;
      border-radius: 5px;
    }

    .selector {
      width: 100%;
      min-width: 140px;
      background: #f7f7f7;
      color: #4dd2ae;
      border: 1px solid #4dd2ae;
      font-size: 16px;
      font-weight: 600;
    }
    .selectHeader {
      gap: 10px;
    }
    .selectList {
      top: 19px;
      padding: 0;
      border: 1px solid #4dd2ae;
      border-top: none;
      .selectItem {
        background: #ffffff;
        color: #4dd2ae;
      }
      .selectItem:hover {
        background: #ecf5f3;
      }
      .selectItem.selected {
        background: #4dd2ae;
        color: #ffffff;
      }
    }
  }

  /* 800px container */
  .contentContainer {
    margin: 0 auto;
    width: 800px;
    margin-top: 42px;
    padding: 47px 80px;
    background: #ffffff;
    border-radius: 10px;
  }
  .contentContainer.wide {
    width: 1000px;
  }
  .contentContainer:nth-child(2),
  .contentContainer:nth-child(3) {
    margin-top: 6px;
  }

  /* wideContainer */
  .wideContainer {
    width: 100%;
    max-width: 1500px;
    min-height: 100%;
    /* max-height: calc(100vh - 54px); */
  }

  /* 타이틀 공통사항  */
  .title h1 {
    margin-bottom: 26px;
    font-size: 28px;
    color: #3b4044;
  }
  /* 저장버튼 공통사항 */
  .submitButtonWrap {
    position: sticky;
    bottom: 0;
    padding: 15px 0 30px 0;
    background: #fff;
    margin-top: auto !important;
  }

  /* tab 공통사항 */
  .tab_wrap {
    width: 100%;

    .tab_line {
      width: 100%;
      padding-bottom: 20px;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    button.tab_item_btn {
      width: 15%;
      padding: 4px 10px;
      margin: 0 1%;
      background: #fafafa;
      border: none;
      outline: none;
      position: relative;
      white-space: nowrap;

      h2 {
        font-size: 18px;
        padding-bottom: 2px;
        font-weight: 600;
      }
    }
  }
  .tab_line button.active {
    font-weight: 600;
    color: #000;
    border-bottom: 6px solid #4dd2ae;
  }

  /* 태블릿 */
  @media (max-width: 1200px) {
    .leftWrap {
      display: none;
    }
    .mobileHeader {
      display: block;
      position: fixed;
      top: 0;
      left: 0;
      z-index: 999;
      width: 100%;
      background: #f7f7f7;
      padding: 24px 0 0 34px;
    }

    .rightWrap {
      padding: 80px 46px;
    }
    .headerButtonWrap {
      all: unset;
      display: flex;
      flex-direction: column;
      gap: 6px;
      align-items: flex-end;
    }
  }

  .menuView {
    padding: 9px 18px !important;
    color: #4dd2ae;
    border: 1px solid #4dd2ae;
    font-size: 16px;
    font-weight: 600;
  }

  /* 모바일 */
  @media (max-width: 900px) {
    .mobileHeader {
      background: #fff;
      padding: 20px 4vw 0 4vw;
    }
    .rightWrap {
      width: 100vw;
      background: #fff;
      padding: 60px 0 0 0;
    }
    .contentContainer {
      width: 100%;
      margin: 0;
      padding: 47px 3vw;
      border-radius: 0;
      border-top: 6px solid #f7f7f7;
    }
    .contentContainer:nth-child(1) {
      border-top: none;
    }
    .contentContainer.wide {
      width: 100%;
    }
    .headerWrap {
      width: 100%;
      padding: 0 3vw;
      justify-content: flex-end;

      .categoryTitle {
        display: none;
      }
      .headerButtonWrap {
        display: flex;
        flex-direction: column;
        .selector {
          background: #ffffff;
        }
      }
    }
  }
`;
